import _validations from 'lodash'
import moment, { MomentInput } from "moment"
import FormConstants, { BillingFormconstants, RequestorFormConstants } from '../../components/dataEntryDetails/dataEntryComponents/DataEntryFieldsConstants'
import { DataEntryActionConstants } from '../../components/dataEntryDetails/DataEntryDetailsDucks'
import { store } from '../../redux/index'
import { DEFAULT_DROPDOWN_NAME, DEFAULT_DROPDOWN_VALUE, API_FETCHING, API_INITIAL } from '../constants/ApiConstants'
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import { NewSendToRequestor } from '../../models/requestor'
import {AssessmentResult, EntityTypeId, RELEASE} from "../../models/assessment";
export const _ = _validations
const REQUIRED = 'Please enter valid '

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: '#474849',
        border: '1px solid #BFD8E8',
        borderRadius: '0.3em',
        fontSize: 12,
        margin: 2
    },
}))(Tooltip);

export function getMomentDate(date: MomentInput, dateFormat: string = "MM/DD/YYYY") {
    if (date) {
        return moment(date).format(dateFormat);
    }
    return "";
}

export function isAPIInitial(...args) {
    const status = false

    return Array.from(args).reduce(
        (returnStatus, item) => returnStatus || parseInt(item, 10) === API_INITIAL,
        status
    )
}

export function isAPIFetching(...args) {
    const status = false

    return Array.from(args).reduce(
        (returnStatus, item) => returnStatus || parseInt(item, 10) === API_FETCHING,
        status
    )
}
export const setGlobalId = async () => {
    if (!global.userID) {
        const id = await sessionStorage.getItem("userID")
        global.userID = id ? Number(id) : 0
        return global.userID
    } else {
        return global.userID
    }
}

export function normalizeData<T>(data: readonly T[], key: keyof(T)) {
    let normalizedData = {}

    for (const item of data) {
        normalizedData = {
            ...normalizedData,
            [item[key] as any]: item
        }
    }

    return normalizedData;
}

export const isValid = (value: any) => {
    if (value && value.toString().length > 0 && value.toString() !== "Invalid Date") {
        return { display_error: false }
    } else {
        return {
            error_msg: REQUIRED,
            display_error: true
        }
    }
}
export const isPHISelected = (value: any) => {
    if (Object.entries(value).length > 0) {
        return {}
    } else {
        return {
            error_msg: REQUIRED,
            display_error: true
        }
    }
}

export const isValidCharacters = (value: any, chars: string) => {
    let re = new RegExp("^[" + chars.replace('\\', '\\\\').replace('-', '\\-').replace(']', '\\]').replace('^', '\\^') + "]*$")
    if (re.test(value)) {
        return { display_error: false }
    } else {
        return {
            error_msg: REQUIRED,
            display_error: true
        }
    }
}

interface InormalizedType {
    [key: string]: any;
}

export const pickerHelperFunction = (dataArray: any[], keyName: string, keyValue: string) => {
    let pickerOptions: InormalizedType[] = []
    dataArray && dataArray.map(item => {
        pickerOptions.push({ value: item[keyValue], label: item[keyName] })
        return null
    })
    return pickerOptions
}

export const generatePickerOptions = (data: any, keyName: string, keyValue: string, keyId = "999999") => {
    if (!data) { return [] }
    let pickerOptions: InormalizedType[] = []
    pickerOptions.push({ value: DEFAULT_DROPDOWN_VALUE, label: DEFAULT_DROPDOWN_NAME })
    Object.keys(data).map((key) => {
        if (keyId !== "999999") {
            pickerOptions.push({ value: data[key][keyValue], label: data[key][keyName], rid: data[key][keyId] })
        } else
            pickerOptions.push({ value: data[key][keyValue], label: data[key][keyName] })
        return null
    })
    return pickerOptions
}

export const generatePickerOptionsUndefinedDefault = (data: any, keyName: string, keyValue: string, keyId = "999999") => {
    if (!data) { return [] }
    let pickerOptions: InormalizedType[] = []
    pickerOptions.push({ value: undefined, label: DEFAULT_DROPDOWN_NAME })
    Object.keys(data).map((key) => {
        if (keyId !== "999999") {
            pickerOptions.push({ value: data[key][keyValue], label: data[key][keyName], rid: data[key][keyId] })
        } else
            pickerOptions.push({ value: data[key][keyValue], label: data[key][keyName] })
        return null
    })
    return pickerOptions
}

export const generatePickerOptionsNoDefault = (data: any, keyName: string, keyValue: string) => {
    if (!data) { return [] }
    let pickerOptions: InormalizedType[] = []
    Object.keys(data).map((key) => {
        pickerOptions.push({ value: data[key][keyValue], label: data[key][keyName] })
        return null
    })
    return pickerOptions
}
export const normalizeCharacters = (value: string, name: string) => {
    if (!value) {
        return value
    }
    let matches: RegExpMatchArray | null;
    if (name === RequestorFormConstants.CITY || name === BillingFormconstants.BILL_TO_CITY) {
        matches = value.match(/[a-zA-Z\s]+/g);
    }
    else if (name === RequestorFormConstants.LAST_NAME) {
        matches = value.match(/[a-zA-Z, ]+/g);
    } else {
        matches = value.match(/[a-zA-Z]+/g);
    }

    if (matches?.length) {
        return matches[0]
    }
    return ""
}

// AB#37970 - closed as working as designed: this deliberately does NOT cap the extension.
// It FORMATS only, keeping every digit past the tenth as `xEXT`, and Classic's
// /^\d{3}-\d{3}-\d{4}(x\d{1,8})?$/ validator (localValidations.ts) reports an over-long
// extension to the specialist rather than truncating it. A cap was tried here and then on the
// Quick Entry entry path, and both were reverted: silently rewriting what someone typed is worse
// than telling them it is wrong. It also matters that this function is called from read-only
// DISPLAY code (DataEntryDetailsLeftPane.tsx) and from SEEDING a form field with already-stored
// data (DataEntryDetailsRightPane.tsx ddsSeedFax/seedFax) - a cap here would mutate stored
// contact data on screens nobody meant to edit.
export const normalizePhone = (value: string) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[^\d]/g, "");

    if (onlyNums.length <= 3) {
        return onlyNums;
    }else if (onlyNums.length <= 6) {
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
    }else if (onlyNums.length <= 10) {
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6)}`;
    }
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}x${onlyNums.slice(10)}`;
};


export const numericAmount = (value: string) => value.replace(/[^\d.]/g, "");


export function getTransactionNotesDataFromObject(data: any, key: string) {
    switch (key) {
        case "date":
            return moment(data?.created).format("MM/DD/YYYY")
        case "type":
            return data?.type?.name
        case "notes":
            return data?.text
        default:
            return ""
    }
}

export function mirrorData(fieldName: string, value?: any) {
    switch (fieldName) {
        case FormConstants.PATIENT_NAME:
            return store.dispatch<any>({ type: DataEntryActionConstants.updatePatientDetails, data: { firstName: value } })
        case FormConstants.PATIENT_MIDDLE_NAME:
            return store.dispatch<any>({ type: DataEntryActionConstants.updatePatientDetails, data: { middleName: value } })
        case FormConstants.PATIENT_LAST_NAME:
            return store.dispatch<any>({ type: DataEntryActionConstants.updatePatientDetails, data: { lastName: value } })
        case FormConstants.DOB:
            return store.dispatch<any>({ type: DataEntryActionConstants.updatePatientDetails, data: { dob: value } })
        case FormConstants.MRN_ID:
            return store.dispatch({ type: DataEntryActionConstants.updateTransactionDetails, data: { mrn: value } })
        case FormConstants.EMPI_NUMBER:
            return store.dispatch({ type: DataEntryActionConstants.updatePatientDetails, data: { empi: value } })
        case RequestorFormConstants.REQUESTOR_NAME:
            return store.dispatch({ type: DataEntryActionConstants.updateRequestorDetails, data: { fullName: value } })
        case "requestorNotes":
            return store.dispatch({ type: DataEntryActionConstants.updateRequestorDetails, data: { "notes": value } })
        case RequestorFormConstants.CITY:
            return store.dispatch({ type: DataEntryActionConstants.updateRequestorDetails, data: { city: value } })
        case RequestorFormConstants.STATE:
            return store.dispatch({ type: DataEntryActionConstants.updateRequestorDetails, data: { state: value } })
        case RequestorFormConstants.ZIP:
            return store.dispatch({ type: DataEntryActionConstants.updateRequestorDetails, data: { zipCode: value } })
        case RequestorFormConstants.ADDRESS:
            return store.dispatch({ type: DataEntryActionConstants.updateRequestorDetails, data: { address1: value } })
        case RequestorFormConstants.ADDRESS2:
            return store.dispatch({ type: DataEntryActionConstants.updateRequestorDetails, data: { address2: value } })
        case FormConstants.AUTHORIZATION_DATE:
            return store.dispatch({ type: DataEntryActionConstants.updateTransactionDetails, data: { authorization: value } })
        case FormConstants.REQUEST_DATE:
            return store.dispatch({ type: DataEntryActionConstants.updateTransactionDetails, data: { request: value } })
        case FormConstants.RECEIVED_DATE:
            return store.dispatch({ type: DataEntryActionConstants.updateTransactionDetails, data: { received: value } })
        case FormConstants.DUE_DATE:
            return store.dispatch({ type: DataEntryActionConstants.updateTransactionDetails, data: { due: value } })
        case "notes":
            return store.dispatch<any>({ type: DataEntryActionConstants.updatePatientDetails, data: { notes: value } })
        default:
            return null
    }
}

export const generateSendToRequestorObject = (data: any, organizationId: number, requestBufferId: number, clearFeeOk: boolean = false): NewSendToRequestor => {
    return {
        organizationId,
        requestBufferId,
        name: data[RequestorFormConstants.REQUESTOR_NAME],
        address1: data[RequestorFormConstants.ADDRESS],
        address2: data[RequestorFormConstants.ADDRESS2] || undefined,
        city: data[RequestorFormConstants.CITY],
        state: data[RequestorFormConstants.STATE],
        zipCode: data[RequestorFormConstants.ZIP],
        clearFeeOk,
    }
}

export const generateUpdateBillToRequestorObject = (data: any) => {
    return {
        requestorbillinglocation: data[BillingFormconstants.BILL_TO_REQUESTOR_NAME],
        firstname: data[BillingFormconstants.BILL_TO_FIRST_NAME],
        lastname: data[BillingFormconstants.BILL_TO_LAST_NAME],
        address1: data[BillingFormconstants.BILL_TO_ADDRESS_LINE1],
        address2: data[BillingFormconstants.BILL_TO_ADDRESS_LINE2] || undefined,
        city: data[BillingFormconstants.BILL_TO_CITY],
        state: data[BillingFormconstants.BILL_TO_STATE],
        zipcode: data[BillingFormconstants.BILL_TO_ZIP],
        country: "United States",
        prepay: data[BillingFormconstants.REQUIRES_PREPAYMENT] === true, // Ensure boolean value,
        email: data[BillingFormconstants.BILL_TO_EMAIL_ADDRESS],
        phone: data[BillingFormconstants.BILL_TO_PHONE],
        fax: data[BillingFormconstants.BILL_TO_FAX],
        billingtypeid: 1,
        userID: global.userID,
        requestorNameId: data.requestorNameId
    }
}

export const generateUpdateDisclosureInformationObject = (data: any) => {
    return {
        disclosureDate: data[FormConstants.DISCLOSURE_DATE] ? moment(data[FormConstants.DISCLOSURE_DATE]).format("MM/DD/YYYY") : null,
        disclosureReasonID: data[FormConstants.DISCLOSURE_REASON],
        protocolNumber: data[FormConstants.PROTOCOL_NUMBER] || '0',
        specialNote: data[FormConstants.SPECIAL_NOTES] || undefined,
        numberOfPages: data[FormConstants.PAGES_DISCLOSED] || undefined,
        protocolName: data[FormConstants.PROTOCOL_NAME] || undefined,
        userID: global.userID,
    }
}

export const generateSendToRequestorContactObject = (data: any, transactionid: string = '') => {
    return {
        emailconfirmed: false,
        userID: global.userID,
        transactionId: transactionid,
        firstname: data[RequestorFormConstants.FIRST_NAME] || undefined,
        lastname: data[RequestorFormConstants.LAST_NAME] || undefined,
        email: data[RequestorFormConstants.EMAIL] || undefined,
        phone: data[RequestorFormConstants.PHONE_NUMBER] || undefined,
        fax: data[RequestorFormConstants.FAX_NUMBER] || undefined,
    }
}

export function generateSearchResponseObject(data: any) {
    let responseObject: any[] = [];
    let requestorName, zip, city, state, firstName, lastName, phone, fax, email, requestorId = '', eTransfer, national, requestorContactId, comments, prePay;
    let requestorAddress = {}
    data.map((requestor) => {
        comments = requestor.comments;
        eTransfer = requestor.eTransfer;
        national = requestor.national;
        requestorName = requestor.fullName ? requestor.fullName : '';
        requestorAddress = {
            address1: requestor.requestorAddress.address1 ? requestor.requestorAddress.address1 : '',
            address2: requestor.requestorAddress.address2 ? requestor.requestorAddress.address2 : '',
            city: requestor.requestorAddress.city ? requestor.requestorAddress.city : '',
            state: requestor.requestorAddress.state ? requestor.requestorAddress.state : '',
            zip: requestor.requestorAddress.zipCode ? requestor.requestorAddress.zipCode : ''

        }
        requestorId = requestor.requestorID || "";
        prePay = requestor.prePay;
        requestor.contacts.length === 0 ? responseObject.push({ requestorId, requestorName, zip, city, state, prePay })
            : requestor.contacts.map((el: any) => {
                firstName = el.firstName ? el.firstName : '';
                lastName = el.lastName ? el.lastName : '';
                phone = el.phone ? el.phone : '';
                fax = el.fax ? el.fax : '';
                email = el.email ? el.email : '';
                requestorContactId = el.id;
                responseObject.push({ requestorName, requestorContactId, requestorAddress, firstName, lastName, phone, fax, email, requestorId, national, eTransfer, comments, prePay });
                return null;
            })
        return null
    });

    return responseObject

}

export function generateContactSearchReponseObject(data: any[]) {
    return data.map(el => ({
        id: el.id || 0,
        firstName: el.firstName || "",
        lastName: el.lastName || "",
        phone: el.phone || "",
        fax: el.fax || "",
        email: el.email || "",
    }))
}

export function generateRejectLetterResponseObject(data: any) {
    let address1, address2, city, state, zipcode, organizationWebsite, phone, fax, fullname, requestorFirstname, requestorLastname,
        requestorAddress1, requestorAddress2, requestorCity, requestorState, requestorZipCode,
        patientFirstName, patientLastName, patientMiddleName, caseNumber, medicalProviderName, logoUrl,
        invoiceNumber = '', requestorEmail, requestorFax, verismaName;
    address1 = data.organizationReturn?.organizationAddress.address1;
    address2 = data.organizationReturn?.organizationAddress.address2;
    city = data.organizationReturn?.organizationAddress.city;
    state = data.organizationReturn?.organizationAddress.state;
    zipcode = data.organizationReturn?.organizationAddress.zipCode;
    organizationWebsite = data.organizationReturn?.organizationWebsite;
    phone = data.organizationReturn?.contactInfo.phone;
    fax = data.organizationReturn?.contactInfo.fax;
    fullname = data.requestor?.fullName;
    requestorFirstname = data.requestor?.requestorInfo.firstName;
    requestorLastname = data.requestor?.requestorInfo.lastName;
    requestorAddress1 = data.requestor?.requestorAddress.address1;
    requestorAddress2 = data.requestor?.requestorAddress.address2;
    requestorCity = data.requestor?.requestorAddress.city;
    requestorState = data.requestor?.requestorAddress.state;
    requestorZipCode = data.requestor?.requestorAddress.zipCode;
    patientFirstName = data.patient?.contact.firstName;
    patientLastName = data.patient?.contact.lastName;
    patientMiddleName = data.patient?.contact.middleName;
    caseNumber = data.caseNumber;
    medicalProviderName = data.medicalProvider?.organizationName;
    invoiceNumber = data.invoiceNumber;
    logoUrl = data.logoUrl;
    requestorEmail = data.requestor?.requestorInfo.email;
    requestorFax = data.requestor?.requestorInfo.fax;
    verismaName = data.verismaName;
    let rejectLetterObject = {
        address1, address2, city, state, zipcode,
        phone, fax, organizationWebsite, fullname, requestorFirstname, requestorLastname,
        requestorAddress1, requestorAddress2, requestorCity, requestorState, requestorZipCode,
        patientFirstName, patientLastName, patientMiddleName, caseNumber, medicalProviderName, invoiceNumber, logoUrl, requestorEmail,
        requestorFax, verismaName
    }
    return rejectLetterObject
}

export const isPastDate = (date: any) => {
    if (date) {
        const now = moment();
        const numberOfDays = now.diff(date, "days");
        return numberOfDays > 0
    }
    return false
}

export const areValuesIdentical = (val1, val2) => {
    const valuesIdentical = (v1, v2) => {
        if (v1 === 'object') {
            if (!objectsIdentical(v1, v2))
                return false;
        } else if (v1 instanceof Array) {
            if (v1.length != v2.length)
                return false;

            v1.forEach((v, i) => {
                if (!valuesIdentical(v, v2[i]))
                    return false;
            })
        } else if (v1 !== v2) {
            return false;
        }
    }

    const objectsIdentical = (o1, o2) => {
        const o1Keys = Object.keys(o1);
        const o2Keys = Object.keys(o2);

        if (o1Keys.length != o2Keys.length)
            return false;

        let keysIdentical = true;

        o1Keys.every((c, i) => {
            if (c !== o2Keys[i] || typeof o1[c] !== o2[c] || !valuesIdentical(o1[c], o2[c])){
                keysIdentical = false;
            }
            return keysIdentical;
        })

        return keysIdentical;
    }

    return valuesIdentical(val1, val2);
}

export function arrayContentsEqual<T>(a: readonly T[], b: readonly T[]) {
    if (a.length != b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (a[i] != b[i]) {
            return false;
        }
    }
    return true;
}

export function getAIEntityCount(data: AssessmentResult, type: "patient" | "auth", comingledFeatureFlag: boolean): number;
export function getAIEntityCount(
    data: AssessmentResult,
    type: "sensitive",
    comingledFeatureFlag: boolean,
    authorizedEntities: {readonly [key in EntityTypeId]?: boolean}
): number;

export function getAIEntityCount(
    data: AssessmentResult,
    type: "sensitive" | "patient" | "auth",
    comingledFeatureFlag?: boolean,
    authorizedEntities?: {readonly [key in EntityTypeId]?: boolean}
): number {
    if (authorizedEntities) {
        return data.detectedEntities.filter(ent =>
            ent.type.toLowerCase() != RELEASE &&
            !authorizedEntities[ent.type]
        ).length;
    } else if (type === "patient") {
        var total = Object.keys(data.patientNameMissingPages).flatMap(page =>
            data.patientNameMissingPages[page]).length;
            
        if (comingledFeatureFlag) {
            total += Object.keys(data.patientNames).flatMap(name =>
                data.patientNames[name]).length;
        }
        
        return total;
    } else {
        return data.detectedEntities.filter(ent =>
            ent.type.toLowerCase() == RELEASE
        ).length;
    }
}